import { PropsWithChildren } from 'react';

import { usePaymentCardStatus } from '@/features/cards/hooks/usePaymentCardStatus';
import { IPaymentCard } from '@/features/cards/store/models/card.model';
import { CardStatus } from '@/features/cards/components/CardDetails/CardStatus';

export function PaymentCardStatus({ paymentCard }: PropsWithChildren<{ paymentCard: IPaymentCard }>) {
  const { status } = usePaymentCardStatus(paymentCard);

  return <CardStatus status={status} />;
}
